import React from 'react';
import classNames from 'classnames';

import SectionFooter from '../PageBuilder/SectionBuilder/SectionFooter/SectionFooter';
import sectionBuilderCss from '../PageBuilder/SectionBuilder/SectionBuilder.module.css';

const DEFAULT_CLASSES = {
  sectionDetails: sectionBuilderCss.sectionDetails,
  title: sectionBuilderCss.title,
  description: sectionBuilderCss.description,
  ctaButton: sectionBuilderCss.ctaButton,
  blockContainer: sectionBuilderCss.blockContainer,
  defaultLink: sectionBuilderCss.defaultLink,
};

/**
 * Render the hosted footer without importing every PageBuilder section.
 *
 * @component
 * @param {Object} props Hosted footer section
 * @returns {JSX.Element}
 */
const FooterSection = props => {
  const isDarkTheme =
    props?.appearance?.fieldType === 'customAppearance' && props?.appearance?.textColor === 'white';
  const classes = classNames({ [sectionBuilderCss.darkTheme]: isDarkTheme });

  return (
    <SectionFooter
      className={classes}
      defaultClasses={DEFAULT_CLASSES}
      options={{ defaultClasses: DEFAULT_CLASSES }}
      {...props}
      sectionId={props.sectionId}
      allSections={[props]}
    />
  );
};

export default FooterSection;
